import { useEffect, useRef } from 'react'
import { useUnifiedAuth } from '@/contexts/UnifiedAuthContext'
import { useOpenReplayStore } from '@/stores/openReplayStore'

export function OpenReplayTracker() {
  const { user, status } = useUnifiedAuth()
  const { init, start, stop, setUserMetadata, isStarted, isInitialized } = useOpenReplayStore()
  const startingRef = useRef(false)

  // Инициализация трекера
  useEffect(() => {
    if (!isInitialized) {
      init()
    }
  }, [isInitialized, init])

  // Управление сессией на основе статуса авторизации
  useEffect(() => {
    // Если не авторизован - останавливаем запись
    if (status === 'unauthenticated') {
      if (isStarted) {
        stop()
      }
      startingRef.current = false
      return
    }

    // Если загружается или нет пользователя - ждём
    if (status !== 'authenticated' || !user || !isInitialized) {
      return
    }

    // Если уже запущен - обновляем метаданные (на случай если данные пользователя изменились)
    if (isStarted) {
      setUserMetadata({
        userId: user.id,
        email: user.email,
        telegramId: user.telegram_id,
        telegramUsername: user.telegram_username,
      })
      return
    }

    // Запускаем сессию с метаданными (один раз)
    if (!startingRef.current) {
      startingRef.current = true
      start({
        userId: user.id,
        email: user.email,
        telegramId: user.telegram_id,
        telegramUsername: user.telegram_username,
      }).finally(() => {
        startingRef.current = false
      })
    }
  }, [user, status, start, stop, setUserMetadata, isStarted, isInitialized])

  return null
}
